import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import countryCodes from "../components/countries/Countries";
import BrandCheckboxDropdown from "../components/DropDown/BrandCheckboxDropdown";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLogin } from "../redux/authSlice";
import toast from "react-hot-toast";
import axios from "axios";
import config from "../config";
import "./RegisterLux.css";

const brandOptions = [
  "Louis Vuitton", "Gucci", "Chanel", "Hermes",
  "Dior", "Prada", "Versace", "Balenciaga",
  "Fendi", "YSL", "Valentino", "Dolce Gabbana",
  "Bottega", "Celine", "Chloe", "MiuMiu", "Goyard",
];

const RegisterLux = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get("ref");
  const emailFromQuery = (searchParams.get("email") || "").trim().toLowerCase();

  const [selectedOption, setSelectedOption] = useState("");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState(emailFromQuery);
  const [insta, setInsta] = useState("");
  const [countryCode, setCountryCode] = useState(Object.keys(countryCodes)[0]);
  const [ddd, setDdd] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [date, setDate] = useState("");
  const [produtoPromo, setProdutoPromo] = useState("");
  const [emailJaCadastrado, setEmailJaCadastrado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedBrands.length < 3) {
      toast.error("Por favor, selecione pelo menos 3 marcas.", { position: "top-center" });
      return;
    }

    const formData = {
      name, email, insta, date, produtoPromo,
      countryCode, ddd, gender, phoneNumber,
      selectedBrands, selectedOption,
      ...(refCode ? { referral_code: refCode } : {}),
    };

    setEmailJaCadastrado(false);

    try {
      const apiUrl = config.API_URL || "http://localhost:8000";
      await axios.post(`${apiUrl}/register`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Registro realizado com sucesso!", { position: "top-center" });
      dispatch(userLogin({ email })).then((data) => {
        if (!data.payload || data.meta?.requestStatus === "rejected") return;
        navigate("/home");
      });
    } catch (error) {
      const status = error?.response?.status;
      const detail = error?.response?.data?.detail || "";
      
      if (status === 409 || (status === 400 && detail.includes("already been registered"))) {
        setEmailJaCadastrado(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      
      toast.error(detail || "Erro ao realizar cadastro. Tente novamente.", { position: "top-center" });
    }
  };

  const isValid = () =>
    name && email && insta && countryCode && ddd &&
    phoneNumber && selectedBrands.length > 2 &&
    selectedOption && date && produtoPromo && gender;

  const formatDate = (input) => {
    const c = input.replace(/\D/g, "");
    return `${c.slice(0, 2)}/${c.slice(2, 4)}/${c.slice(4, 8)}`;
  };

  const handleBrandChange = (brand) => {
    setSelectedBrands((prev) =>
      prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand]
    );
  };

  return (
    <div className="reglux-root">
      <div className="reglux-shell">
        {/* Back */}
        <Link to="/" className="reglux-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Voltar
        </Link>

        {/* Email já cadastrado */}
        {emailJaCadastrado && (
          <div style={{
            padding: "16px 20px",
            borderRadius: "14px",
            background: "linear-gradient(135deg, rgba(220,53,69,.10), rgba(220,53,69,.04))",
            border: "1px solid rgba(220,53,69,.35)",
            textAlign: "center",
            marginBottom: "4px",
          }}>
            <p style={{ color: "#c0392b", fontWeight: 700, fontSize: "15px", margin: "0 0 6px" }}>
              Este email já está cadastrado
            </p>
            <p style={{ color: "#6b3030", fontSize: "13px", margin: "0 0 12px" }}>
              Parece que você já tem uma conta conosco. Faça login para acessar o clube VIP.
            </p>
            <Link
              to="/"
              style={{
                display: "inline-block",
                padding: "10px 24px",
                borderRadius: "30px",
                background: "linear-gradient(135deg, #c0392b, #922b21)",
                color: "#fff",
                fontWeight: 700,
                fontSize: "14px",
                textDecoration: "none",
                letterSpacing: "0.5px",
              }}
            >
              Ir para o Login
            </Link>
          </div>
        )}

        {/* GIF */}
        <div className="reglux-gif-wrap">
          <div className="reglux-gif-ratio">
            <iframe
              src="https://giphy.com/embed/8ZzPIFi9Dqv5cqJkDE"
              title="Register Animation"
              className="giphy-embed"
              allowFullScreen
              sandbox="allow-same-origin allow-scripts"
            />
          </div>
        </div>

        {emailFromQuery && (
          <div style={{
            padding: "12px 16px",
            borderRadius: "14px",
            background: "linear-gradient(135deg, rgba(212,175,55,.08), rgba(212,175,55,.03))",
            border: "1px solid rgba(212,175,55,.2)",
            textAlign: "center",
            fontSize: "13px",
            color: "#B8962E",
            fontWeight: 600,
          }}>
            Esse e-mail veio da landing. Completa o cadastro pra entrar no app.
          </div>
        )}

        {/* Referral badge */}
        {refCode && (
          <div style={{
            padding: "12px 16px",
            borderRadius: "14px",
            background: "linear-gradient(135deg, rgba(212,175,55,.08), rgba(212,175,55,.03))",
            border: "1px solid rgba(212,175,55,.2)",
            textAlign: "center",
            fontSize: "13px",
            color: "#B8962E",
            fontWeight: 600,
          }}>
            Você foi indicada por uma amiga! Ganhe bônus extra ao se cadastrar.
          </div>
        )}

        {/* Banner */}
        <div className="reglux-banner">
          <h2>
            Acesse nossas <span>promoções exclusivas</span>
          </h2>
          <p>Preencha o formulário e ganhe acesso ao nosso clube VIP.</p>
        </div>

        {/* Form */}
        <div className="reglux-form-card">
          <p className="reglux-form-title">Queremos saber mais de você</p>

          <form onSubmit={handleSubmit}>
            {/* Nome */}
            <div className="reglux-field">
              <label className="reglux-label">Qual seu nome?</label>
              <input
                className="reglux-input"
                type="text"
                placeholder="Nome completo"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {/* Email */}
            <div className="reglux-field">
              <label className="reglux-label">Email de acesso</label>
              <input
                className="reglux-input"
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setEmailJaCadastrado(false); }}
              />
            </div>

            <div className="reglux-divider">contato</div>

            {/* WhatsApp */}
            <div className="reglux-field">
              <label className="reglux-label">WhatsApp</label>
              <div className="reglux-phone-row">
                <select
                  className="reglux-select"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                >
                  {Object.keys(countryCodes).map((code) => (
                    <option key={code} value={code}>
                      {code} {countryCodes[code]}
                    </option>
                  ))}
                </select>
                <input
                  className="reglux-input"
                  type="text"
                  placeholder="DDD"
                  value={ddd}
                  onChange={(e) => setDdd(e.target.value)}
                />
                <input
                  className="reglux-input"
                  type="text"
                  placeholder="Seu número"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
            </div>

            {/* Instagram */}
            <div className="reglux-field">
              <label className="reglux-label">@ do seu Instagram</label>
              <input
                className="reglux-input"
                type="text"
                placeholder="@seuinsta"
                value={insta}
                onChange={(e) => setInsta(e.target.value)}
              />
            </div>

            <div className="reglux-divider">preferências</div>

            {/* Marcas */}
            <div className="reglux-field reglux-brands">
              <label className="reglux-label">
                3 marcas que você mais ama
              </label>
              <BrandCheckboxDropdown
                brandOptions={brandOptions}
                selectedBrands={selectedBrands}
                handleBrandChange={handleBrandChange}
              />
              {selectedBrands.length > 0 && (
                <p className="reglux-selected-brands">
                  Selecionadas: {selectedBrands.join(", ")}
                </p>
              )}
            </div>

            {/* Bolsa de griffe */}
            <div className="reglux-field">
              <label className="reglux-label">
                Já tem alguma bolsa de griffe?
              </label>
              <div className="reglux-radio-group">
                {["Ainda não", "Tenho uma", "Tenho várias, amo!"].map((opt) => (
                  <div className="reglux-radio-option" key={opt}>
                    <input
                      type="radio"
                      name="bolsa"
                      id={`bolsa-${opt}`}
                      value={opt}
                      checked={selectedOption === opt}
                      onChange={(e) => setSelectedOption(e.target.value)}
                    />
                    <label className="reglux-radio-label" htmlFor={`bolsa-${opt}`}>
                      {opt}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Aniversário */}
            <div className="reglux-field">
              <label className="reglux-label">
                Seu aniversário (adoramos presentear)
              </label>
              <input
                className="reglux-input"
                type="text"
                placeholder="DD/MM/AAAA"
                value={date}
                onChange={(e) => setDate(formatDate(e.target.value))}
              />
            </div>

            {/* Gênero */}
            <div className="reglux-field">
              <label className="reglux-label">Gênero</label>
              <div className="reglux-radio-group">
                {[
                  { value: "feminino", label: "Feminino" },
                  { value: "masculino", label: "Masculino" },
                ].map((opt) => (
                  <div className="reglux-radio-option" key={opt.value}>
                    <input
                      type="radio"
                      name="genero"
                      id={`genero-${opt.value}`}
                      value={opt.value}
                      checked={gender === opt.value}
                      onChange={(e) => setGender(e.target.value)}
                    />
                    <label className="reglux-radio-label" htmlFor={`genero-${opt.value}`}>
                      {opt.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Produto promo */}
            <div className="reglux-field">
              <label className="reglux-label">
                Quais produtos você quer na promo?
              </label>
              <input
                className="reglux-input"
                type="text"
                placeholder="Bolsas, sapatos, acessórios..."
                value={produtoPromo}
                onChange={(e) => setProdutoPromo(e.target.value)}
              />
            </div>

            {/* Submit */}
            <button
              type="submit"
              className="reglux-submit"
              disabled={!isValid()}
            >
              Quero Acesso VIP
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterLux;
